import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { AnnouncementMutationKeys } from '../../../keys'
import { deleteAnnouncement } from '../../services'

interface UseMutationDeleteAnnouncementProps {
	id: string
}

export default function useMutationDeleteAnnouncement(
	props?: UseBaseMutationOptions<void, UseMutationDeleteAnnouncementProps>,
) {
	return useMutation({
		mutationKey: [AnnouncementMutationKeys.deleteAnnouncement],
		mutationFn: ({ id }) => deleteAnnouncement(id),
		...props,
	})
}
